import {CalendarClock} from "lucide-react";
import {useNavigate} from "react-router-dom";
import {useTranslationWithKeys} from "../../hooks/useTranslationWithKeys";
import {NotificationBanner} from "./banners/NotificationBanner";

interface SemesterSetupBannerProps {
    onClose: () => void;
}

export function SemesterSetupBanner({onClose}: SemesterSetupBannerProps) {
    const {t} = useTranslationWithKeys();
    const navigate = useNavigate();

    return (
        <NotificationBanner
            variant="neutral"
            icon={<CalendarClock/>}
            message={t('settings.educational.setupBanner.message')}
            description={t('settings.educational.setupBanner.description')}
            action={{
                label: t('settings.educational.setupBanner.action'),
                onClick: () => navigate("/settings?tab=educational"),
            }}
            onClose={onClose}
        />
    );
}
